import { render, staticRenderFns } from "./AppTopbar.vue?vue&type=template&id=478c2088&scoped=true"
import script from "./AppTopbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTopbar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppTopbar.vue?vue&type=style&index=0&id=478c2088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c2088",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopbarLocation: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/components/TopbarLocation.vue').default,TopbarLanguage: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/components/TopbarLanguage.vue').default})
